import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
} from "@chakra-ui/react";
import { useForm, useFormContext } from "react-hook-form";

export function Filter() {
  const {setValue} = useFormContext()
  const { register, getValues } = useForm();

  const onSubmit = () => {
    const values = getValues()

    setValue('filter', {
      nome: values.nome,
      email: values.email,
    })
  }

  return (
    <Box fontSize={'sm'} px={{xs: 2, md: 10}} flexDir={'column'}>
      <SimpleGrid columns={{xs: 1, md: 3}} w={'full'} gap={1}>
        <FormControl>
          <FormLabel width={{xs: '50%', md: '30%'}}>Nome</FormLabel>
          <Input type="text" size={'xs'} {...register("nome")} />
        </FormControl>
        <FormControl>
          <FormLabel width={{xs: '50%', md: '30%'}}>Email</FormLabel>
          <Input width={'100%'} type="text" size={'xs'} {...register("email")} />
        </FormControl>
      </SimpleGrid>
      <Flex justifyContent={'start'} mt={4} gap={4}>
        <Button onClick={onSubmit} w={'8rem'} colorScheme="blue" borderRadius={'none'} size={'sm'}>PESQUISAR</Button>
        <Button onClick={() => window.location.href = `/usuario/novo`} w={'8rem'} colorScheme="blue" borderRadius={'none'} size={'sm'}>NOVO</Button>
      </Flex>
    </Box>
  );
}
